import { createSelector } from '@reduxjs/toolkit';

import { getUser } from '../selectors';

const getProgressiveWebApp = createSelector(getUser, ({ progressiveWebApp }) => progressiveWebApp);

const isInstallable = createSelector(getProgressiveWebApp, ({ installable }) => installable);

const getModalStep = createSelector(
  getProgressiveWebApp,
  progressiveWebApp => progressiveWebApp.modalStep
);

const getShownState = createSelector(getProgressiveWebApp, ({ timesShown, lastShown }) => ({
  timesShown,
  lastShown,
}));

const getTimesShown = createSelector(getShownState, ({ timesShown }) => timesShown ?? 0);

const canPrompt = createSelector(getShownState, ({ timesShown }) => {
  // Allow app store prompt up to 5 times
  return (timesShown ?? 0) < 5;
});

export default {
  isInstallable,
  getModalStep,
  getShownState,
  getTimesShown,
  canPrompt,
};
